import React from "react";
import styled from "styled-components";
import LOGO from "../../assets/LOGO.png";

const Footer = () => {
  return (
    <TheFooter>
      <div className="top-footer">
        <div className="left-top">
          <a href="/" className="logo">
            <img src={LOGO} alt="app-logo" />
          </a>
          <p>
            <b>Contact : </b>
          </p>
          <a href="tel:+13022133509">+1 302 213 3509</a>
          <a href="mailto:sales@medichy.com">sales@medichy.com</a>
          <a href="mailto:support@medichy.com">support@medichy.com</a>
        </div>
        <div className="center-top">
          <p>
            <b>Important Links : </b>
          </p>
          <div className="links-grid">
            <a href="/startups">Startups</a>
            <a href="/oems">OEMs</a>
            <a href="/products">Products</a>
            <a href="/prototype-sprint">Prototype Sprint</a>
            <a href="/designs">Design & Development</a>
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/contact-us">Contact</a>
          </div>
        </div>
        <div className="right-top">
          <p>
            <b>Location : </b>
          </p>
          <p className="address">1496 McKee & Joanna Crescent Rd, Dover, DE 19901</p>
        </div>
      </div>
      <div className="bottom-footer">
        <p>© Medichy. All rights reserved.</p>
      </div>
    </TheFooter>
  );
};

const TheFooter = styled.div`
  width: 100%;
  padding: 4rem 2rem 0rem 2rem;
  background: var(--primary-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;

  .top-footer {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    padding: 1rem 0 2rem 0;

    p {
      font-size: 1.2rem;
    }

    .left-top {
      display: flex;
      align-items: flex-start;
      justify-content: start;
      flex-direction: column;
      gap: 1rem;

      .logo {
        width: 10rem;
        background: white;
        padding: 1rem;
        border-radius: 1rem;

        img {
          width: 100%;
        }
      }

      a {
        color: white;
        font-size: 0.8rem;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .center-top {
      display: flex;
      align-items: flex-start;
      justify-content: start;
      flex-direction: column;
      gap: 1rem;

      .links-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.8rem 2rem;
      }

      a {
        color: white;
        font-size: 0.8rem;
        text-decoration: none;
        white-space: nowrap;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .right-top {
      display: flex;
      align-items: flex-start;
      justify-content: start;
      flex-direction: column;
      gap: 1rem;

      .address {
        color: white;
        font-size: 0.8rem;
        max-width: 200px;
        line-height: 1.4;
      }
    }
  }

  .bottom-footer {
    width: 100%;
    text-align: center;
    padding: 1rem;
    border-top: 1px solid white;

    p {
      font-size: 0.6rem;
    }
  }

  @media screen and (max-width: 1366px) {
    padding: 3rem 1.5rem 0rem 1.5rem;

    .top-footer {
      .left-top {
        .logo {
          width: 9rem;
          padding: 0.8rem;
        }
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .top-footer {
      p {
        font-size: 1.1rem;
      }

      .center-top {
        .links-grid {
          gap: 0.8rem 1.5rem;
        }
      }
    }
  }

  @media screen and (max-width: 900px) {
    padding: 3rem 1.2rem 0rem 1.2rem;

    .top-footer {
      flex-direction: column;
      gap: 2.5rem;
      align-items: center;
      text-align: center;

      .left-top {
        align-items: center;
        text-align: center;
      }

      .center-top {
        align-items: center;
        text-align: center;

        .links-grid {
          grid-template-columns: repeat(3, 1fr);
          text-align: center;
        }
      }

      .right-top {
        align-items: center;
        text-align: center;

        .address {
          max-width: 300px;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    padding: 2.5rem 1rem 0rem 1rem;

    .top-footer {
      gap: 2rem;

      p {
        font-size: 1rem;
      }

      .left-top {
        display:none;
        .logo {
          width: 8rem;
          padding: 0.7rem;
        }

        a {
          font-size: 0.9rem;
        }
      }

      .center-top {
        .links-grid {
          grid-template-columns: repeat(2, 1fr);
          gap: 0.8rem 1.2rem;
        }

        a {
          font-size: 0.9rem;
        }
      }

      .right-top {
        display:none;
        .address {
          font-size: 0.9rem;
          max-width: 250px;
        }
      }
    }

    .bottom-footer {
      p {
        font-size: 0.7rem;
      }
    }
  }

  @media screen and (max-width: 420px) {
    padding: 2rem 0.8rem 0rem 0.8rem;

    .top-footer {
      gap: 1.8rem;

      .left-top {
        gap: 0.8rem;
        display:none;

        .logo {
          width: 7rem;
          padding: 0.6rem;
        }
      }

      .center-top {
        .links-grid {
          grid-template-columns: 1fr;
          text-align: center;
          gap: 0.7rem;
        }
      }

      .right-top {
        gap: 0.8rem;
        display:none;
      }
    }

    .bottom-footer {
      padding: 0.8rem;

      p {
        font-size: 0.65rem;
      }
    }
  }

  @media screen and (max-width: 350px) {
    padding: 1.5rem 0.5rem 0rem 0.5rem;

    .top-footer {
      gap: 1.5rem;

      p {
        font-size: 0.9rem;
      }

      .left-top {
        display:none;
        .logo {
          width: 6rem;
          padding: 0.5rem;
        }

        a {
          font-size: 0.8rem;
        }
      }

      .center-top {
        a {
          font-size: 0.8rem;
        }
      }

      .right-top {
        display:none;
        .address {
          font-size: 0.8rem;
        }
      }
    }

    .bottom-footer {
      padding: 0.6rem;

      p {
        font-size: 0.6rem;
      }
    }
  }
`;

export default Footer;
